<template>
    <b-form-group :label="label" :class="classGroup">
            <DatePicker DatePicker v-mask="'##/##/####'" :value="date" type="date" format="DD/MM/YYYY" @input="inputDateHandler">
                    <template v-slot:icon-calendar><DynamicIcon icon="calendar-gray" classString="icon-calendar-datepicker"/></template>
            </DatePicker>
          <b-form-invalid-feedback :state="state">
                {{validationMessage}}
          </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
import DateUtils from "@/util/DateUtils"
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pt-br';
import moment from "moment"
import { mask } from 'vue-the-mask'
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";


export default {
    directives: { mask },
    components: {
        DatePicker,
        DynamicIcon
    },
    props : {
          label: String,
          value: [String, Date, Number],
          validationMessage: String,
          classGroup: String
    },
    data() {
          let data = {
                dateTemp: null
          }

          this.changeTempFromParent(this.value, data)

          return data
    },
    computed: {
          state() {
                if (this.validationMessage == null) {
                      return null
                }

                return !this.validationMessage
          },
          date() {
                return this.parseDate(this.value)
          }
    },
    methods: {
          changeTempFromParent(value, data) {
                data.dateTemp = this.parseDate(this.value)
          },
          inputDateHandler(date) {
                this.inputValue(date)
          },
          inputValue(date)
          {
                this.dateTemp = date

                if (!date) {
                      this.$emit('input', null)
                      return
                }

                this.$emit('input', moment(date).toDate().toISOString())
          },
          parseDate(value) {
                return DateUtils.parse(value)
          }
    },
    watch: {
          value (value) {
                this.changeTempFromParent(value, this)
          }
    }
}
</script>

<style>
.form-group .mx-datepicker {
    width: 100%;
    border-radius: 0.25rem;
    display: flex;
    flex: 1;

}

.mx-input-wrapper {
    position: relative;
    width: 100%;
}

html body .icon-calendar-datepicker{
      margin-bottom: 0px !important;
}

html body fieldset.form-group{
      margin-bottom: 0px !important;
}

</style>
